export enum NotificationIds {
  NEVER = 1,
  INSTANTLY = 2,
  DAILY = 3,
  WEEKLY = 4,
};
